var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_11_Project"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_11_Project",
    clipPath: "url(#clip-Icons_Selected_11_Project)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_11_Project-2",
    "data-name": "Icons_Selected_11_Project",
    transform: "translate(-6.1 2.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer",
    transform: "translate(81.822 64.029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 262.139,
    cy: 262.139,
    r: 262.139,
    transform: "translate(0)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M137.392,91.4,63.029,104.643,54.2,159.312,74.574,214.66l66.214,3.735L168.631,180.7v-47.2Z",
    transform: "translate(115.228 202.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(6.1 6.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 13.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M276.728,552.056C127.322,552.056,6.1,430.494,6.1,281.428,6.1,132.022,127.662,10.8,276.728,10.8A264.15,264.15,0,0,1,382.67,32.532a8.22,8.22,0,0,1,4.414,11.205,8.22,8.22,0,0,1-11.205,4.414,254.839,254.839,0,0,0-99.151-20.034c-139.9,0-253.65,113.752-253.65,253.65s113.752,253.65,253.65,253.65,253.65-113.752,253.65-253.65a254.572,254.572,0,0,0-30.56-120.883,8.509,8.509,0,1,1,14.941-8.149,270.644,270.644,0,0,1,32.6,129.032C547.356,430.494,425.794,552.056,276.728,552.056Z",
    transform: "translate(-6.1 -10.8)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(89.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(113.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M212.536,143.147c-5.093-1.7-9.847-4.754-14.6-7.47-19.015-10.187-42.105-11.205-63.158-6.452a132.354,132.354,0,0,0-67.233,38.71c-1.019,1.019-2.037,2.037-1.7,3.4a3.9,3.9,0,0,0,2.037,3.056c10.526,8.829,21.392,17.657,32.258,26.146,1.358,1.019,2.716,2.037,4.414,2.037s2.716-1.358,4.075-2.377c23.769-21.732,62.139-24.448,88.964-6.791,18.336,11.885,29.2,31.239,32.6,52.632,3.056,18.676-6.791,41.087-27.165,44.482,5.433,13.243,18,25.467,26.486,37.012,7.131,9.168,41.087-34.975,44.822-42.105,13.582-25.127,12.564-57.046-4.075-80.815-5.772-8.149-16.3-15.62-11.885-26.486,3.4-8.489,13.582-13.582,20.373-19.015,10.866-8.829,22.071-17.317,33.277-25.467,22.75-16.638,45.84-32.258,69.949-46.52,3.735-2.037,7.81-4.754,8.149-9.168.34-1.7-.34-3.735-.679-5.433C384.693,55.2,374.506,37.883,359.9,26.338,351.416,17.849,331.042.872,318.139,9.021c-5.433,3.4-11.885,13.243-16.3,18-6.452,7.131-11.545,15.62-16.3,23.769-16.978,28.523-31.579,59.083-52.292,84.89-2.377,2.716-4.754,5.773-8.149,7.131C221.7,145.184,216.951,144.844,212.536,143.147Z",
    transform: "translate(-65.78 -6.865)",
    fill: "#633fda"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 208.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M296.337,189.522c-13.582-3.056-27.5-5.433-41.766-7.47a101.759,101.759,0,0,0-6.112-13.922,76.562,76.562,0,0,0-8.149-12.224c14.6-22.411,25.127-39.728,27.5-45.161l-47.878-30.56a7.12,7.12,0,0,0-3.735-1.358c-1.7,0-3.056,1.358-4.075,2.716a440.025,440.025,0,0,0-30.56,39.728,86.97,86.97,0,0,0-13.243-1.019C156.778,93.427,147.61,73.393,144.215,68.3,126.9,76.11,109.58,83.58,92.262,91.39a8.667,8.667,0,0,0-3.4,2.377c-.679,1.358-.34,3.4,0,4.754,4.414,15.62,9.847,31.239,15.62,46.52a87.52,87.52,0,0,0-16.638,20.713C60,162.7,32.84,158.962,32.5,156.246c.679,22.411,1.358,45.161,2.037,67.572,0,1.358,16.978,4.075,42.105,7.47a91.085,91.085,0,0,0,9.508,25.806c.679,1.358,1.7,2.377,2.377,3.735-14.261,20.713-27.5,39.049-29.881,38.031,20.374,9.847,40.407,20.034,60.781,29.881,1.019.34,9.508-10.187,21.732-27.5a92.151,92.151,0,0,0,30.56,3.735c8.489,21.392,15.28,40.068,13.243,41.426,19.355-11.205,39.049-22.75,58.4-33.956,1.019-.679-3.4-13.922-10.866-33.956A87.181,87.181,0,0,0,251.855,250.3c22.75,2.037,39.728,3.056,44.822,2.377,1.358-19.015,3.056-37.691,4.414-56.706,0-1.358.34-2.716-.679-4.075C299.733,190.541,298.035,189.862,296.337,189.522Zm-103.9,49.236c-6.791,5.093-15.28,7.81-23.769,9.508a50.974,50.974,0,0,1-12.564,1.7c-8.149-.34-15.62-4.414-21.053-10.187s-9.168-12.9-12.224-20.713c-14.941-40.068,53.311-61.8,73.684-28.523a52.4,52.4,0,0,1,5.772,14.261,39.012,39.012,0,0,1,2.377,12.224C204.656,225.855,199.223,234,192.432,238.758Z",
    transform: "translate(-32.5 -68.3)",
    fill: "#633fda"
  }))))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_11_Project.4c7a33a4.svg";
export { SvgComponent as ReactComponent };